import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';
import {WalletStore} from "@features/wallet/application/store/wallet.store";
import {PaymentStatus, PaymentStatusChangedEvent} from "@platform/event-bus/domain/events/payment/payment-status-changed.event";
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";

@Injectable({providedIn: 'root'})
export class WalletOnPaymentSucceededSubscriber {
  private readonly store = inject(WalletStore);
  private readonly eventBus = inject(EventBusPort);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.eventBus.ofType(PaymentStatusChangedEvent)
      .pipe(
        tap(({payload}) => {
          if (payload.status === PaymentStatus.SUCCESS && payload.amount !== undefined) {
            this.store.setLastPayment(payload.amount);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
